import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter027() {
  return <KbChapterPage slug="chapter-027" />;
}

(Chapter027 as unknown as { path: string }).path = "/theory-album/027";
